<template>
    <div>
      <!-- 基本模板 -->
        <div class="container" v-if="['common', 'dynamic', 'tabs', 'compare', 'balance', 'download', 'report'].indexOf(config.ctrl) >= 0">
            <PageHeader style="margin:10px 0 0 0;"/>
            <div class="content page_main_content">
                <component :is="ctrl_component"></component>
            </div>
        </div>
        <!-- 特殊模板 -->
        <component :is="ctrl_component" :parent="config.parent" :name="config.name" v-else></component>
    </div>
</template>

<script>
import moment from "moment"

export default {
    props: {
        // 数据接口
        api: {
            type: String,
        },
    },
    components: {
    },
    data() {
        return {
            
        }
    },
    computed: {
        config() {
            return this.$store.state.config.page
        },
        ctrl_component() {
            if(!this.config.ctrl) {
                return null
            }
            if(['common', 'dynamic', 'tabs', 'compare', 'balance', 'download', 'report'].indexOf(this.config.ctrl) >= 0) {
                return  require(`@/components/game/page/${this.config.ctrl}.vue`).default
            }
            return  require(`@/components/game/ctrl/${this.config.ctrl}.vue`).default
        }
    },
    watch: {
    },
    mounted() {
      this.getData()
    },
    methods: {
        getData() {
            this.$service.query_fixed_module(this.api).then((data)=>{
              this.$store.dispatch('init_page_config', data)
            })
        }
    }
}
</script>

<style lang="less">
#test_overview {
    .page_breadcrumb {
        display: none;
    }
    .page_searcher {
        display: none;
    }
}
</style>